import * as React from 'react'

import SuggestionsListItem, { ISuggestion } from './suggestionsListItem'

interface IProps {
  suggestions: ISuggestion[]
  styles: { [key: string]: string }
  focusedIndex: number
  inputValue: string
  textInputRef: HTMLInputElement
  wrapperRef: HTMLDivElement
  setMenuRef: React.LegacyRef<HTMLElement>
  onMenuClick: () => void
  handleMenuMouseEnter: () => void
  handleMenuMouseLeave: () => void
}

const SuggestionsList = (props: IProps) => {
  const {
    suggestions,
    styles,
    focusedIndex,
    inputValue,
    textInputRef,
    wrapperRef,
    setMenuRef,
    onMenuClick,
    handleMenuMouseEnter,
    handleMenuMouseLeave
  } = props
  /**
   * Hack inline style :magic:
   */
  const wrapperStyle: React.CSSProperties = {
    position: 'absolute',
    top: textInputRef.clientHeight,
    width: wrapperRef.clientWidth
  }

  return (
    <div className={styles.wrapper} style={wrapperStyle}>
      <section ref={setMenuRef} className={styles.suggestions}>
        <ul className="fds-c-text-list -style-none">
          {suggestions.map((suggestion, index) => {
            let showSeparator = false
            if (
              index > 0 &&
              suggestions[index - 1].type !== suggestions[index].type
            ) {
              showSeparator = true
            }

            return (
              <SuggestionsListItem
                styles={styles}
                focusedIndex={focusedIndex}
                inputValue={inputValue}
                onMenuClick={onMenuClick}
                handleMenuMouseLeave={handleMenuMouseLeave}
                handleMenuMouseEnter={handleMenuMouseEnter}
                key={index}
                suggestion={suggestion}
                index={index}
                showSeparator={showSeparator}
              />
            )
          })}
        </ul>
      </section>
    </div>
  )
}

export default SuggestionsList
